'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AggregationTypeSelect = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AggregationTypeSelect = function AggregationTypeSelect(refs) {
    var i18n = refs.i18nManager.get();
    var optionConfig = refs.optionConfig;

    return Ext.create('Ext.form.field.ComboBox', {
        cls: 'ns-combo',
        style: 'margin-bottom:' + _Style2.default.comboBottomMargin + 'px',
        width: _Style2.default.cmpWidth,
        labelWidth: _Style2.default.labelWidth,
        fieldLabel: i18n.aggregation_type,
        labelSeparator: null,
        labelStyle: 'color:#333',
        queryMode: 'local',
        valueField: 'id',
        displayField: 'name',
        editable: false,
        value: optionConfig.getAggregationType('def').id,
        store: Ext.create('Ext.data.Store', {
            fields: ['id', 'name', 'index'],
            data: optionConfig.getAggregationTypeRecords()
        })
    });
};

exports.AggregationTypeSelect = AggregationTypeSelect;
exports.default = AggregationTypeSelect;
//# sourceMappingURL=AggregationType.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/AggregationType.js
 ** module id = 349
 ** module chunks = 0
 **/